module.exports = __webpack_public_path__ + "static/cloud-b38df1e084c6b826f47601f1571a63f4.png";